import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const ApprovalPendingIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 1C3.84315 1 2.5 2.34315 2.5 4V16C2.5 17.6569 3.84315 19 5.5 19H14.5C16.1569 19 17.5 17.6569 17.5 16V4C17.5 2.34315 16.1569 1 14.5 1H5.5ZM6.4001 5.60059C5.95827 5.60059 5.6001 5.95876 5.6001 6.40059C5.6001 6.84241 5.95827 7.20059 6.4001 7.20059H13.6001C14.0419 7.20059 14.4001 6.84241 14.4001 6.40059C14.4001 5.95876 14.0419 5.60059 13.6001 5.60059H6.4001ZM5.6001 10.0002C5.6001 9.55837 5.95827 9.2002 6.4001 9.2002H13.6001C14.0419 9.2002 14.4001 9.55837 14.4001 10.0002C14.4001 10.442 14.0419 10.8002 13.6001 10.8002H6.4001C5.95827 10.8002 5.6001 10.442 5.6001 10.0002ZM6.4001 12.7998C5.95827 12.7998 5.6001 13.158 5.6001 13.5998C5.6001 14.0416 5.95827 14.3998 6.4001 14.3998H13.6001C14.0419 14.3998 14.4001 14.0416 14.4001 13.5998C14.4001 13.158 14.0419 12.7998 13.6001 12.7998H6.4001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ApprovalPendingIcon;
